(function () {
  const root = document.querySelector('.blog-prj');
  if (!root) return;

  /* ── READING PROGRESS ── */
  const progress = root.querySelector('#progress');
  if (progress) {
    window.addEventListener('scroll', function () {
      const h = document.documentElement;
      const total = h.scrollHeight - h.clientHeight;
      const pct = total > 0 ? (h.scrollTop / total) * 100 : 0;
      progress.style.width = pct + '%';
    }, { passive: true });
  }

  /* ── FADE-UP ON SCROLL ── */
  if ('IntersectionObserver' in window) {
    const fuObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          fuObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });

    root.querySelectorAll('.fu').forEach(function (el) {
      fuObs.observe(el);
    });
  }

  /* ── LUX BARS ── */
  (function () {
    const bars = root.querySelectorAll('.lux-bar[data-pct]');
    if (!bars.length || !('IntersectionObserver' in window)) return;

    const luxObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.width = e.target.getAttribute('data-pct') + '%';
          luxObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });

    bars.forEach(function (b) {
      luxObs.observe(b);
    });
  })();

  /* ── FAQ ACCORDION ── */
  root.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.parentElement;
      const isOpen = item.classList.contains('open');
      root.querySelectorAll('.faq-item').forEach(function (i) {
        i.classList.remove('open');
      });
      if (!isOpen) item.classList.add('open');
    });
  });
})();

/* ── GALLERY PROTECT + LIGHTBOX ── */
(function () {
  // สร้าง lightbox
  var lbWrap = document.createElement('div');
  lbWrap.className = 'lb-wrap';
  lbWrap.innerHTML = '<span class="lb-close">×</span><img id="lbImg" src="" alt="">';
  document.body.appendChild(lbWrap);

  // คลิกนอกรูป หรือกด × → ปิด
  lbWrap.addEventListener('click', function () {
    lbWrap.classList.remove('open');
  });

  // กด Escape → ปิด
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') lbWrap.classList.remove('open');
  });

  // ใส่ overlay ทุกรูปใน gallery
  document.querySelectorAll('.gal-item').forEach(function (item) {
    var img = item.querySelector('img');
    if (!img) return;

    // block right-click ที่ตัว img
    img.addEventListener('contextmenu', function (e) { e.preventDefault(); });

    // overlay ใส ทับรูป
    var ov = document.createElement('div');
    ov.className = 'gal-protect';
    ov.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    ov.addEventListener('click', function () {
      document.getElementById('lbImg').src = img.src;
      document.getElementById('lbImg').alt = img.alt || '';
      lbWrap.classList.add('open');
    });
    item.appendChild(ov);
  });
})();